import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { NoImagePlaceholder } from '../../index';

const ListerBar = styled.div`
  height: 100%;
  width: 2px;
  background: ${props => props.bg};
`;

const Wrapper = styled.div`
  width: 98px;
  display: flex;
  gap: 0px;
  height: 72px;
  border-radius: 3px;
  position: relative;
`;

const StyledImage = styled.img`
  width: 96px;
  height: 72px;
  border-radius: 3px;
  object-fit: cover;
  cursor: pointer;
`;

const VehicleImage = ({ id, user, history, images, showListerBar = false }) => {
  const [image] = images;

  const bg = (() => {
    if (!showListerBar || !user?.referrer_user?.options?.color) return 'transparent';
    return user?.referrer_user?.options?.color;
  })();

  if (image && image.url_thumb) {
    return (
      <Wrapper>
        <ListerBar bg={bg} />
        <StyledImage src={image.url_thumb} onClick={() => history.push(`/vehicles/${id}/details`)} />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <ListerBar bg={bg} />
      <NoImagePlaceholder />
    </Wrapper>
  );
};

export default withRouter(VehicleImage);
